
<template>
  <div>
    <detail v-if="useMessage.所属项目"  :useMessage="useMessage"/>
    <clist
      v-else
      :title="'客户信息完善'"
      @click="onUserSelect"
      :req="{  }"
    ></clist>
  </div>
</template>
<script>
import detail from ".//detail.vue";
import clist from "../clist/index";

export default {
  name: "commodityList",
  components: {
    // RecordItem,
    clist,
    detail,
  },
  props: {
    // Detail,
    // commodity: {
    //   type: Object,
    //   default: () => {
    //     return {};
    //   },
    // },
  },

  data() {
    return {
      useMessage: {
        所属项目: "新基业当代阅ΜΟΜΛ",
        客户姓名: "",
        性别: "1",
        客户电话: "",
        客户地区: "",
        详细地址: "",
        完整地址: "",
      },
      // searchStr: "",
      // //imgUrlPath: ImgUrlPath.ImgUrlPath,
      // offset: 100,
      // pagesize: 10,
      // pagenum: 1,
      // total: 0,
      // dataList: [],
      // list: [],
      // loading: false,
      // finished: false,
      // refreshing: false,
      // curtime: new Date().getTime()
    };
  },

  watch: {
    // commodity(newV,oldV) {
    //   this.onRefresh();
    // }
  },
  methods: {
    onUserSelect(user) {
      this.useMessage = user;
      // this.$router.push('/returnvisit/' + user.客户电话)
    },
    //   onCancel() {
    //     this.pagenum = 1;
    //     this.searchStr = "";
    //     this.getList();
    //   },
    //   onRefreshStart() {
    //     this.pagenum = 1;
    //     this.getList();
    //   },
    //   // 获取数据
    //   getList() {
    //     this.loading = true;
    //     let data = {
    //       paging: {
    //         limit: 10,
    //         page: this.pagenum,
    //       },
    //       req: {},
    //     };

    //     if (this.searchStr != "") {
    //       data.req.username = { $regex: this.searchStr };
    //     }
    //     this.$request
    //       .customerList(data)
    //       .then((res) => {
    //         console.log(res);
    //         this.loading = false;
    //         if (res.code == 0) {
    //           if (this.pagenum == 1) {
    //             this.list = res.data.items;
    //           } else {
    //             this.list = this.list.concat(res.data.items);
    //           }
    //           this.dataList = this.list;
    //           this.total = res.data.total;
    //           if (this.dataList.length >= this.total) {
    //             this.finished = true;
    //           }
    //         }
    //       })
    //       .catch(() => {
    //         this.finished = true;
    //       });
    //   },

    //   onRefresh() {
    //     this.pagenum = 1;
    //     this.finished = false;

    //     this.getList();
    //     this.refreshing = false;
    //   },
    //   onLoad() {
    //     this.pagenum++;
    //     this.getList();
    //   },
    // },
    // mounted() {
    //   this.$nextTick(() => {
    //     this.getList();
    //     // this.$store.dispatch("setCacheObjFirstLoad", false);
    //     // this.onRefresh()
    //   });
  },
};
</script>
<style scoped lang="less">
#commodityList {
  margin-top: 10px;
  padding: 0 10px;

  .commodityBox {
    flex-wrap: wrap;
    font-size: 14px;

    .commodityContainer {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 10px !important;
      border-radius: 20px;

      // box-shadow: #666 5px 5px 5px;
      .textBox {
        margin: 5px 0px 5px 0px;

        .colon {
          display: inline-block;
          margin: 0 4px;
          color: black;
        }

        .block {
          display: inline-block;
          width: 30px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          background-color: #ee0a24;
        }

        .batch {
          color: green;
        }

        .batch p {
          margin: 3px;
        }
      }
    }
  }
}
</style>